import { Injectable } from '@angular/core';
import { Router } from '@angular/router'
import { Token } from '../manager/token';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators'
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class TmsReportService {
  TokenCls

  constructor(private http: HttpClient, private router: Router) {
    this.TokenCls = new Token(this.router);
  }

  GetReportDownload(formbody): any {
    return this.http.post(environment.ApiUrl + '/api/Get_Time_Motion_Report', formbody, { responseType: 'blob'})
      .pipe(map(res => {
        return {
          filename: 'TMSReport.xlsx',
          data: res
        };
      }))
  }

  GetAllEmployees(id): any {
    return this.http.get(environment.ApiUrl + '/api/Get_Employees/client/' + id);
  }
}
